var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"scrollable":"","max-width":"500"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('elac-card-title',{attrs:{"label":_vm.title},on:{"close":function($event){_vm.show = false}}}),_c('v-card-text',[_vm._v(_vm._s(_vm.message))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }